// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2SKUX","footer":"ModalUpdate_footer__zitDD"};